/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import { Notification } from 'types/entities/Notification'
import NotificationItem from './UiNotificationsDropdownItem'
import UiStateView from 'components/Ui/UiStateView'

interface UiNotificationsDropdownListProps {
    notifications: Notification[]
    onClick: (notification: Notification) => void
    translate: (value: string) => string
}

const UiNotificationsDropdownList = (
    props: UiNotificationsDropdownListProps
) => {
    if (props.notifications.length === 0) {
        return (
            <UiStateView
                variant="empty"
                compact
                title={props.translate('No notifications')}
                className="UiNotificationsDropdownList px-4 py-8"
            />
        )
    }

    return (
        <div className="UiNotificationsDropdownList">
            {props.notifications.map((notification) => (
                <NotificationItem
                    key={notification.id}
                    notification={notification}
                    onClick={props.onClick}
                    t={props.translate}
                />
            ))}
        </div>
    )
}

export default UiNotificationsDropdownList
